import { render, staticRenderFns } from "./TabelaEscore.vue?vue&type=template&id=3855e66e&scoped=true"
import script from "./TabelaEscore.vue?vue&type=script&lang=js"
export * from "./TabelaEscore.vue?vue&type=script&lang=js"
import style0 from "./TabelaEscore.vue?vue&type=style&index=0&id=3855e66e&prod&lang=css"
import style1 from "./TabelaEscore.vue?vue&type=style&index=1&id=3855e66e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3855e66e",
  null
  
)

export default component.exports